import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref } from 'vue-property-decorator';
import Heatmap from 'heatmap.js';
let detailHotMap = class detailHotMap extends Vue {
    MapList;
    width;
    height;
    heatmap;
    hotMapList = [];
    mapSize = { width: 160, height: 90 };
    mounted() {
        if (this.MapList) {
            this.hotMapList = this.MapList;
            const heatMapWidthScale = (this.width / this.mapSize.width) * 1; // 当前容器宽比例
            const heatMapHeightScale = (this.height / this.mapSize.height) * 1; // 当前容器高比例
            this.hotMapList = this.hotMapList.map((item) => {
                return {
                    x: parseInt(`${item.x * heatMapWidthScale}`),
                    y: parseInt(`${item.y * heatMapHeightScale}`),
                    value: item.value,
                    // radius configuration on point basis
                    radius: heatMapWidthScale + 20,
                };
            });
            setTimeout(() => {
                this.getMap();
            }, 0);
        }
    }
    getMap() {
        let that = this;
        var heatmapInstance = Heatmap.create({
            // container: document.getElementById('heatmap'),
            container: that.heatmap,
            maxOpacity: 0.5,
            minOpacity: 0,
        });
        const points = this.hotMapList;
        const data = {
            max: 255,
            min: 1,
            data: points,
        };
        heatmapInstance.setData(data);
    }
};
__decorate([
    Prop({
        default() {
            return [];
        },
    })
], detailHotMap.prototype, "MapList", void 0);
__decorate([
    Prop()
], detailHotMap.prototype, "width", void 0);
__decorate([
    Prop()
], detailHotMap.prototype, "height", void 0);
__decorate([
    Ref()
], detailHotMap.prototype, "heatmap", void 0);
detailHotMap = __decorate([
    Component
], detailHotMap);
export default detailHotMap;
